//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "coin"
}



// WEBPACK FOOTER //
// ./src/components/coin/coin.vue